<template>
    <send-list-form
        v-bind="$props"
        @created="onCreated"
    ></send-list-form>
</template>

<script>
  import SendListForm from "../../components/send-list/form";
  import {modes} from "../../components/send-list/types";

  export default {
    components: {
      SendListForm,
    },

    props: {
      initialModel: {
        type: Object,
        default: function () {
          return {};
        },
      },
      users: {
        type: null,
        default: function () {
          return [];
        },
      },
      storeUrl: {
        type: String,
      },
      canSelectUser: {
        type: Boolean,
        default: false,
      },
      introMessage: {
        type: null,
        default: null,
      },
      mode: {
        type: String,
        default: modes.normal,
      }
    },

    methods: {
      onCreated({model, redirect, message}) {
        window.location.replace(redirect);
      },
    },
  }
</script>

